import { ref, readonly } from 'vue'

const isLoading = ref(false)
export default () => {
  const start = () => (isLoading.value = true)
  const stop = () => (isLoading.value = false)
  return { isLoading: readonly(isLoading), start, stop }
}
